/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Meta_DescInputs */

const en_rd_meta_desc = /** @type {(inputs: Rd_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score any public GitHub repo out of 100 on how ready it is for AI coding agents: instructions, tests, CI, lint, docs — and secrets left in the tree.`)
};

const id_rd_meta_desc = /** @type {(inputs: Rd_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilai repo GitHub publik mana pun dari 100: instruksi, tes, CI, lint, dokumentasi — plus kunci rahasia yang masih tertinggal di repo.`)
};

/**
* | output |
* | --- |
* | "Score any public GitHub repo out of 100 on how ready it is for AI coding agents: instructions, tests, CI, lint, docs — and secrets left in the tree." |
*
* @param {Rd_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_meta_desc = /** @type {((inputs?: Rd_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_meta_desc(inputs)
	return en_rd_meta_desc(inputs)
});